"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var RadioAndCheckbox_1 = require("../RadioAndCheckbox");
var Typo_1 = require("../Typo");
var styled_1 = require("./styled");
var BlockLabel_1 = require("../../v2/components/BlockLabel");
var themes_1 = require("../../themes");
var getBlockLabelProps_1 = require("../../utils/getBlockLabelProps");
var _EXPORTS_1 = require("../../utils/_EXPORTS");
var mixins_1 = require("../../themes/mixins");
var DropdownSingle_1 = require("../Dropdowns/DropdownSingle");
var greyColor10 = themes_1.colors.greyColor10;
function GroupQuestionsInputSingle(_a) {
    var options = _a.options, subQuestionLabels = _a.subQuestionLabels, onChange = _a.onChange, value = _a.value, readOnly = _a.readOnly, id = _a.id, _b = _a.questionColWidth, questionColWidth = _b === void 0 ? 200 : _b, _c = _a.radioColsWidth, radioColsWidth = _c === void 0 ? 120 : _c, _d = _a.variant, _variant = _d === void 0 ? 'radio' : _d, _e = _a.popOutOfOverflowHiddenParent, popOutOfOverflowHiddenParent = _e === void 0 ? false : _e;
    var screenWidth = (0, _EXPORTS_1.useScreenWidth)();
    var variant = (screenWidth < (0, mixins_1.getBreakPoint)("sm") || _variant === 'dropdown')
        ? 'dropdown'
        : 'radio';
    var props = arguments[0];
    var handleChange = function (subQuestionValue, option) {
        // const key = `${label.trim().replaceAll(' ','').toLowerCase()}.${subQuestionValue}`
        var _a;
        var display = option.display, optionValue = option.value;
        onChange(id, __assign(__assign({}, (value || {})), (_a = {}, _a[subQuestionValue] = { display: display, value: optionValue }, _a)));
    };
    return (react_1.default.createElement("div", null,
        react_1.default.createElement(BlockLabel_1.BlockLabel, __assign({}, (0, getBlockLabelProps_1.getBlockLabelProps)(props))),
        react_1.default.createElement("div", { style: variant === 'radio' ? { overflowX: "auto", overflowY: "hidden" } : undefined }, variant === 'radio' ? (react_1.default.createElement(styled_1.StyledTable, null,
            react_1.default.createElement("thead", null,
                react_1.default.createElement("tr", null,
                    react_1.default.createElement("th", { style: {
                            width: "".concat(questionColWidth, "px"),
                            minWidth: "".concat(questionColWidth, "px"),
                            borderBottom: "1px solid ".concat(greyColor10),
                        } }),
                    " ", options === null || options === void 0 ? void 0 :
                    options.map(function (option) { return (react_1.default.createElement(styled_1.StyledTableTh, { style: {
                            width: "".concat(radioColsWidth, "px"),
                            minWidth: "".concat(radioColsWidth, "px"),
                        }, key: option === null || option === void 0 ? void 0 : option.value },
                        react_1.default.createElement(styled_1.StyledElem, null,
                            react_1.default.createElement(Typo_1.SANS_3, { semibold: true }, option === null || option === void 0 ? void 0 : option.display)))); }))),
            react_1.default.createElement("tbody", null, subQuestionLabels === null || subQuestionLabels === void 0 ? void 0 : subQuestionLabels.map(function (subQuestion, i) { return (react_1.default.createElement(styled_1.StyledTableRow, { key: subQuestion === null || subQuestion === void 0 ? void 0 : subQuestion.value, index: i },
                react_1.default.createElement("td", null,
                    react_1.default.createElement("div", { style: { padding: "1rem" } },
                        react_1.default.createElement(Typo_1.SANS_3, { semibold: true }, subQuestion === null || subQuestion === void 0 ? void 0 : subQuestion.display))), options === null || options === void 0 ? void 0 :
                options.map(function (option, i) {
                    var _a;
                    return (react_1.default.createElement("td", { key: "".concat(subQuestion === null || subQuestion === void 0 ? void 0 : subQuestion.value, "-").concat(option === null || option === void 0 ? void 0 : option.value), style: { borderLeft: "1px solid ".concat(greyColor10) } },
                        react_1.default.createElement(styled_1.StyledElem, null,
                            react_1.default.createElement(RadioAndCheckbox_1.RadioButton, { readOnly: readOnly, isSelected: (value &&
                                    (subQuestion === null || subQuestion === void 0 ? void 0 : subQuestion.value) &&
                                    ((_a = value[subQuestion.value]) === null || _a === void 0 ? void 0 : _a.value) ===
                                        (option === null || option === void 0 ? void 0 : option.value)) ||
                                    false, onClick: function () {
                                    return !readOnly &&
                                        handleChange(subQuestion === null || subQuestion === void 0 ? void 0 : subQuestion.value, option);
                                } }))));
                }))); })))) : (react_1.default.createElement("div", { style: { display: 'flex', flexDirection: 'column', gap: '2rem' } }, subQuestionLabels.map(function (subQuestion) { return (react_1.default.createElement("div", null,
            react_1.default.createElement(Typo_1.SANS_2, { semibold: true, style: { paddingBottom: "1rem" } }, subQuestion.display),
            react_1.default.createElement(DropdownSingle_1.DropdownSingle, { readOnly: readOnly, options: options, popOutOfOverflowHiddenParent: popOutOfOverflowHiddenParent, value: value && value[subQuestion.value], onChange: function (k, v) {
                    handleChange(subQuestion.value, v);
                } }))); }))))));
}
exports.default = GroupQuestionsInputSingle;
